<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding container" v-else-if="loaded"  > 
        
        <div class="row" >
            <div class="col-12 text-left" >
                <router-link :to="{name: 'Business Accelerator' }" class="not-active text-left btn btn-transparent border-none btn-sm" > 
                    <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back 
                </router-link>
            </div>
        </div>
        
        <div class="col-12 col-md-10 offset-md-1 p-0 mt-3" >
            <img src="@/assets/images/business_accelerator_1200x628-01.png" class="w-100" />
        </div>
        
        <div class="text-justify mt-5 mb-3 h3" style="line-height: 1.5;" >

        </div>
        
        <!-- ACADEMY -->
        <div class="accordion mt-5" role="tablist">
            
            <!-- INTRO -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-0 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Introduction
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion0" > {{ calculateRead('accordion0') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion0" >
                        
                        Most people will focus on the front-end and neglect the back-end, which is way more important in order to scale your business.
                        <br><br>
                        What most people don’t know is that most of your money will be made on the back end. Some businesses will lose money for 60-90 days with the frontend offer but make 10 times on the backend.
                        <br><br>
                        In recent years, Facebook’s cost has increased and will probably continue to do so in some niches, as more and more people start advertising and bidding. For example, if you are selling a front-end offer for $50 with some upsells and order bumps, your AOV would be between $70-$100.
                        <br><br>
                        If you’ve got a CPA of $50 or $60, it will be hard to scale. Some days you will be making profits, some days you won’t. That’s why you need to have a backend offer so the majority of your profits, your big bucks will come from them.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- INTRO -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-1 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        So what are backend offers?
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion1" > {{ calculateRead('accordion1') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion1">
                        
                        Backend offers are high-ticket offers that bring more value to the product or solution than the initial purchase.
                        <br><br>
                        However, backend offers require more of your or your team's time, since they are higher in value.
                        <br><br>
                        Most customers won’t buy the backend offer the first time around, because they purchased the frontend offer. However, you can craft your backend offer accordingly: nurture them and offer it after 15, 30, 60 or 90 days.
                        <br><br>
                        Between 5-10% of customers always want more.
                        <br><br>
                        Most backend offers are high-ticket offers, that means a minimum of $500 and <strong>should fix a KEY pain point that a regular low ticket offer cannot</strong>. And most of the money made here is net profit. 
                        <br><br>
                        Backend offers will most likely involve more personal touch, so it’s best to offer them to existing customers, via:
                        - Email <br>
                        - Webinars <br>
                        - Phone closes <br>
                        - Live events <br>
                        - Calls <br>
                        - Membership sites <br>
                        - Masterminds <br>
                        - Affiliate programs <br>
                        - Cross-sells: similar products 
                        <br><br>
                        You can also sell it via retargeting ads but the audience needs to be warm. It’s much harder to sell high-ticket offers, for example $1000 programs, to cold prospects.
                        <br><br>
                        <strong>Example full offer ( front-end + back-end ):</strong> <br>
                        - Low-ticket front-end offer you sell of a very low price ( $20 book, course ) <br>
                        - Have a sequence to ascend the customer to a high-ticket offer: coaching masterminds, accelerator ( $997 12 week accelerator ) <br>
                        - High-converting backend leads customer to other high-ticket products ( 10k - 12 month mastermind )
                        <br><br>
                        Think of how easy you can scale your business using high-ticket backend offers. <br>
                        $100 front-end offer sold via ads <br>
                        $1500 backend offer sold via a call or follow-up email
                        <br><br>
                        You can run your business with an ads campaign paying $100 for each conversion. Meaning you make $0 on the front-end, but you make $1500 pure profit on the backend.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
        
          </div>
        <!-- ACADEMY -->

        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default{
    name: "ACADEMY_sales_page",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            text: `
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
              richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
              brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
              tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
              assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
              wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
              vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
              synth nesciunt you probably haven't heard of them accusamus labore VHS.
            `
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            
            
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        
        calculateRead( target ){
            
            //console.log( ev )
            setTimeout( function(){
                
                //console.log( this.$refs )
                //console.log( this.$refs[target].innerHTML )                
                
                let ev = this.$refs[target].innerHTML
                
                const wordsPerMinute = 150; // Average case.
                let result;
                
                let textLength = ev.split(" ").length; // Split by words
                if(textLength > 0){
                    let value = Math.ceil(textLength / wordsPerMinute);
                    result = `~${value} min read`;
                }
                //return result
                //this.$refs[target].appendChild( result )
                document.getElementById(target).innerHTML = result;
                
            }.bind(this), 400 )
                
        }
    },
    computed: {

    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/courses/business-accelerator/04-backend.vue